import { writable } from 'svelte/store'

const seedbank = writable([
    // {
    //     id: 's3',
    //     parentId: 'p2',
    //     commonName: "Tomatoes",
    //     seedName: "Juliet", 
    //     description: "A larger sister variety of Santa, Juliet is one of the most disease resistant in our trials. Deep red, shiny fruits avg. 2-2 1/4\" L x 1 3/8-1 1/2\" W, weighing 1 1/2-2 oz. Typically 12-18 fruits per cluster. Delicious, rich tomato flavor for salads, great salsa, and fresh pasta sauce. Good crack resistance, vine storage, and shelf life. Intermediate resistance to early blight and late blight. AAS winner. "
    // }
    
])


const customSeedbankStore = {
    subscribe: seedbank.subscribe,
    addSeed:(seedData) => {
        seedbank.update(items => {
            return [ seedData, ...items]
        })
}}

export default customSeedbankStore;
